import React, { FC, PropsWithChildren } from 'react';
import { Text, View } from 'react-native';
import { scale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import TouchableElement from '@components/common/touchableElement';
import { isWeb } from '@helpers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface SendingToMachineModalWrapperProps extends PropsWithChildren {
  C: ColorFunction;
  title: string;
  hide: () => void;
}

const SendingToMachineModalWrapper: FC<SendingToMachineModalWrapperProps> = ({ C, title, hide, children }) => {
  return (
    <View testID={TEST_IDS.sendToMachinePopup.root} style={{ flex: 1, paddingHorizontal: scale(15), paddingBottom: scale(15) }}>
      <View
        style={{
          marginVertical: scale(9),
          paddingLeft: scale(12),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: scale(36),
        }}
      >
        <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>{i18n.t(title)}</Text>
        <TouchableElement onPress={hide}>
          {({ pressHoverColor }) => (
            <Text
              style={[font.Body, { paddingHorizontal: scale(12), color: C(pressHoverColor('Link/Light/Primary')) }, isWeb && { cursor: 'pointer' }]}
            >
              {i18n.t('Cancel')}
            </Text>
          )}
        </TouchableElement>
      </View>

      {children}
    </View>
  );
};

export default SendingToMachineModalWrapper;
